module.exports = __webpack_public_path__ + "images/eight-year-club-4de21df56752f4b9e491cf0b30e440a0.png";